var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableTooltip)?_c('el-savitarna-alert',{attrs:{"dense":"","outlined":"","type":"info"}},[_c('span',{staticClass:"tooltip-santrauka",domProps:{"innerHTML":_vm._s(_vm.tooltipTekstas)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }